class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setHeaderCartIconAccessibility());
    } else {
      this.setHeaderCartIconAccessibility();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    if (cartLink.hasAttribute('data-cart-drawer-bound')) return;

    cartLink.setAttribute('data-cart-drawer-bound', 'true');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    var self = this;
    var drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;

    function doRender(sections) {
      self.getSectionsToRender().forEach((section) => {
        var sectionHtml = sections && sections[section.id];
        if (!sectionHtml) return;
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement) return;
        var html = typeof sectionHtml === 'string' ? sectionHtml : '';
        if (!html) return;
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
        if (!inner) return;
        if (section.id === 'cart-drawer') {
          var drawerFooter = sectionElement.querySelector('.drawer__footer');
          var newDrawerFooter = inner.querySelector('.drawer__footer');
          var cartDrawerItems = sectionElement.querySelector('cart-drawer-items');
          var newCartDrawerItems = inner.querySelector('cart-drawer-items');
          var drawerInnerEmpty = sectionElement.querySelector('.drawer__inner-empty');
          if (drawerInnerEmpty) {
            sectionElement.innerHTML = inner.innerHTML;
          } else if (drawerFooter && newDrawerFooter && cartDrawerItems && newCartDrawerItems) {
            cartDrawerItems.replaceWith(newCartDrawerItems);
            var ecCartFooter = drawerFooter.querySelector('.ec-cart-footer');
            var newEcCartFooter = newDrawerFooter.querySelector('.ec-cart-footer');
            if (ecCartFooter && newEcCartFooter) {
              var subtotalEl = ecCartFooter.querySelector('.ec-cart-footer__subtotal-value');
              var newSubtotalEl = newEcCartFooter.querySelector('.ec-cart-footer__subtotal-value');
              var totalEl = ecCartFooter.querySelector('.ec-cart-footer__total-value');
              var newTotalEl = newEcCartFooter.querySelector('.ec-cart-footer__total-value');
              var pixEl = ecCartFooter.querySelector('.ec-payment-pix-value');
              var newPixEl = newEcCartFooter.querySelector('.ec-payment-pix-value');
              var installmentEl = ecCartFooter.querySelector('.ec-payment-installment-value');
              var newInstallmentEl = newEcCartFooter.querySelector('.ec-payment-installment-value');
              if (subtotalEl && newSubtotalEl) {
                subtotalEl.textContent = newSubtotalEl.textContent;
                subtotalEl.setAttribute('data-cart-subtotal-sem-desconto', newSubtotalEl.getAttribute('data-cart-subtotal-sem-desconto') || '0');
              }
              if (totalEl && newTotalEl) {
                totalEl.textContent = newTotalEl.textContent;
                totalEl.setAttribute('data-cart-subtotal', newTotalEl.getAttribute('data-cart-subtotal') || '0');
              }
              if (pixEl && newPixEl) pixEl.textContent = newPixEl.textContent;
              if (installmentEl && newInstallmentEl) installmentEl.textContent = newInstallmentEl.textContent;
            }
            var newCheckoutBtn = newDrawerFooter.querySelector('#CartDrawer-Checkout');
            var checkoutBtn = drawerFooter.querySelector('#CartDrawer-Checkout');
            if (checkoutBtn && newCheckoutBtn) checkoutBtn.replaceWith(newCheckoutBtn);
          } else {
            sectionElement.innerHTML = inner.innerHTML;
          }
        } else {
          sectionElement.innerHTML = inner.innerHTML;
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
      document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: parsedState }));
      setTimeout(function() {
        var overlay = self.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', self.close.bind(self));
        self.open();
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('cart:dom-updated', { detail: Object.assign({}, parsedState, { source: 'drawer-opened' }) }));
        }, 100);
      }, 0);
    }

    if (parsedState.sections && parsedState.sections['cart-drawer']) {
      doRender(parsedState.sections);
      return;
    }

    fetch((typeof routes !== 'undefined' ? routes.cart_url : '/cart') + '?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var sectionEl = doc.querySelector('[id*="cart-drawer"]') || doc.querySelector('cart-drawer') || doc.querySelector('.shopify-section');
        parsedState.sections = parsedState.sections || {};
        parsedState.sections['cart-drawer'] = sectionEl ? sectionEl.outerHTML : '';
        doRender(parsedState.sections);
      })
      .catch(function() {
        doRender(parsedState.sections || {});
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);
